<template>
  <div>
    <v-layout>
      <v-flex xs12 sm6>
        <v-list>
          <v-list-tile
            v-for="(item, index) in blackList"
            :key="`${item.tag}_${index}`"
            no-action
          >
              <v-list-tile-content>
                <v-list-tile-title v-text="item.tag"></v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>

                <v-btn
                  color="error"
                  :disabled="!isWriteAvailable"
                  fab flat
                  @click.stop="deleteTag(item.id)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import ContentField from '@/components/shared/ContentField'
import { mapActions, mapGetters } from 'vuex'
import { required, numeric } from 'vuelidate/lib/validators'
import mixins from '@/utils/mixins'

  export default {
    name: 'blackList',
    mixins: [mixins.isWriteAvailable],
    components: {
      ContentField
    },
    data () {
      return {
        items: {},
        defaultItem: {
          title: '',
          description: ''
        },
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'registration:write'
      }
    },
    computed: {
      ...mapGetters(['blackList'])
    },
    methods: {
      ...mapActions([
        'getBlackList',
        'addToBlacklist',
        'deleteFromBlacklist',
        'showResultErrorMessage'
      ]),
      save () {
        this.close()
      },
      async deleteTag (id) {
        try {
          await this.deleteFromBlacklist(id)
          await this.getBlackList()
        } catch (err) {
          this.showResultErrorMessage(err)
        }
      },
    },
    beforeMount () {
      this.getBlackList()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Registration/Attendee/blackList.vue